module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAATCAYAAACk9eypAAAA9klEQVQokXXRMShEcRzA8c8dCyWDxcSg2GxkZb4ymXXKoORsbNdNmCjKoOiMNrHKynobm5ssBilKXWd4ns7v/u+3ve///3n/3vuXpmrtK6z4Py3M4Tt0ZWzgNfRZ1OPmHLxhPbG2g4UUgFuch7UBNDGcArCNl4CmsV8EPlBFN6BNLKUA3OM4tBIuMJoCsIun0CZwWAS+sIpO6FUspwA84ibRG0VgHpVEr6fAEC4xGHoT1ymwh5nQ2qjR/9GL2AqtizW8RzAi+9+lAE5wlz/0giNMhs3Psnv5mxxUfo/tnY7sPj4jGMOZ/jnAQ4xlnGI89BYaiZf4AX1BK5r3IpwKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/icon3.png
// module id = iTb3
// module chunks = 1